// extracted by mini-css-extract-plugin
module.exports =  {"bottom-divider":"fOPsS3","bottomDivider":"fOPsS3"};